import React from 'react';
import { Grid, Button } from '@material-ui/core';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';

function FilterButtons({ filterMode, selectMode }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid spacing={1} direction="row" alignItems="center" justify="center" container>
      <Grid item>
        <Button
          onClick={() => selectMode('all')}
          variant="contained"
          className={filterMode === 'all' ? classes.button : classes.root}>
          {t('products-all')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          onClick={() => selectMode('available')}
          variant="contained"
          className={filterMode === 'available' ? classes.button : classes.root}>
          {t('product-available')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          onClick={() => selectMode('booked')}
          className={filterMode === 'booked' ? classes.button : classes.root}
          variant="contained">
          {t('products-reserved')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          onClick={() => selectMode('sold')}
          className={filterMode === 'sold' ? classes.button : classes.root}
          variant="contained">
          {t('products-sold')}
        </Button>
      </Grid>
    </Grid>
  );
}

export default FilterButtons;
